import { Injectable, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'

export class AimsCommonPopupEditorData {
  constructor(public header: string, public isNew: boolean, public contentData: any, public formGroup: any, public useRaw: boolean = false) {}
}
